import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
} from "@angular/core";
import { ChartOptions, ChartType } from "chart.js";
import { Label, PluginServiceGlobalRegistrationAndOptions } from "ng2-charts";
import { SubSink } from "subsink";

import { DialogService, ConfigurationService } from "@/shared-module/services";
import { ZoneComponent } from "@/shared-module/components";
import { Configuration, DonutChartDatasource } from "@/shared-module/models";

@Component({
  selector: "app-donutchart",
  templateUrl: "donutchart.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class DonutChartComponent implements ZoneComponent, OnInit, OnDestroy {
  @ViewChild("template", { static: true }) template;
  @Input() data: DonutChartDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  subs = new SubSink();
  rgbColor: string;

  public doughnutChartPlugins: PluginServiceGlobalRegistrationAndOptions[] = [
    {
      beforeDraw(chart) {
        const ctx = chart.ctx;

        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
        const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

        ctx.font = "38px Montserrat";
        ctx.fillStyle = chart.canvas.getAttribute("rgbColor");
        const textToDisplay = chart.canvas.getAttribute("displayText");

        ctx.fillText(textToDisplay, centerX, centerY);
      },
    },
  ];

  // Doughnut
  public chartLabels: Label[] = [];
  public chartData: any = [];

  public chartType: ChartType = "doughnut";
  public chartOptions: ChartOptions = {
    cutoutPercentage: 70,
    responsive: true,
    aspectRatio: 1,
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 20,
      },
    },
    legend: {
      display: false,
    },
  };
  public colors = [];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c.rgb;
      },
    );
  }

  zoom() {
    this.dialogService.setZoomInfo(this.data.zoomInfo);
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    if (this.data) {
      this.colors = [{ backgroundColor: this.data.colors }];
      this.chartLabels = this.data.labels;

      this.chartData = {
        rgbColor: this.rgbColor,
        text: this.data.innerText,
        chartData: [this.data.values],
      };
    }
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
